import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from "@gemini/ui";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { useBrandContext } from "@/shared/contexts/BrandContext";
export const PrivacyPolicyModal = ({ isOpen, onOpenChange }) => {
    const { t } = useI18n();
    const { legal: { link2 }, } = useBrandContext();
    const privacyPolicyText = t("contact.form.legal_text.privacy_modal");
    const privacyPolicyTextWithLinks = privacyPolicyText.replace("{link2}", `<a target="_blank" href="${link2.href}">${t("contact.form.legal_text.link_label_two")}</a>`);
    return (_jsx(Modal, { title: t("contact.form.legal_text.modal_label_two"), titleAs: "h2", isDismissable: true, trigger: () => null, isOpen: isOpen, onOpenChange: onOpenChange, children: _jsx(Box, { paddingTop: 0, typography: "typography.body.12.regular", dangerouslySetInnerHTML: { __html: privacyPolicyTextWithLinks } }) }));
};
